<template>
  <ProgressBar v-if="ifLoaded"></ProgressBar>
  <div class="p-2 text-center" v-else>
    <p class="title hh1 gordo2 mb-4" style="color: rgb(0, 98, 228);">ue-tulcan.com</p>
    <v-typical class="blink" :steps="['Hola', 1000, '' + $store.getters.user.name + '', 500, 'Bienvenido ! 👋', 1000]" :loop="Infinity"
      :wrapper="'h2'"></v-typical>
    <p class="text-letras2 text-tamanio mt-3">La plataforma donde puedes llevar el registro de notas en línea, <br>
      crear horarios, aulas virtuales, generar reportes de todo tipo y <br> enviar notificaciónes masivas.</p>
    <p class="text-letras2 text-tamanio">¿Visitaste este sitio hace tiempo y lo ves distinto? ¡Es porque <br> lo estamos
      renovando para ti!</p>
      <button class="btn btn-base2 btn-verde mt-5" @click="count">Actualizar tu cuenta</button>
      <br> <br> <br>
      
  </div>
</template>
<style lang="scss">
.title {
  animation: pulse 2s infinite ease-out;
}
@keyframes pulse {
  to {
    transform: scale(1);
    opacity: 0.1;
  }
}
.custom-rotate-transition {
  &-enter-from {
    transform: translate(0, 30px) rotate(20deg);
    opacity: 0;
  }

  &-leave-to {
    transform: translate(0, 30px) rotate(10deg);
    opacity: 0;
  }
}

.custom-from-bottom-transition {
  &-enter-from {
    transform: translate(0, 100%);
    opacity: 0;
  }

  &-leave-to {
    transform: translate(0, -30%);
    opacity: 0;
  }
}

.blink::after {
  content: '|';
  animation: blink 1s infinite step-start;
}

.blink {
  color: var(--text-letras);
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>
<script setup>
import ProgressBar from '@/shared/ProgressBar.vue';
import { inject, ref, onMounted } from "vue";
import VTypical from 'vue-typical';
const $proxies = inject("$proxies");
const $toast = inject('toast')
const progress = inject("progress");
const ifLoaded = ref(true)

const count = () => $toast.show(`Su cuenta premium esta al día`);

const authenticate = async () => {
  try {
    ifLoaded.value = true
    progress.start();
    await $proxies.identityProxy.userFound();
    ifLoaded.value = false
    progress.finish();
  } catch (error) {
    ifLoaded.value = false
    progress.finish();
  }
};

onMounted(() => {
  document.body.classList.remove("modal-open");
  authenticate();
});
</script>
